import { useCallback, useEffect, useRef } from "react";

// Focuses the first field showing an error (or the fallback) once React has painted it.
export const useFocusFirstInvalid = () => {
    const timer = useRef();
    useEffect(() => () => clearTimeout(timer.current), []);
    return useCallback((root, fallback) => {
        clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            (root?.querySelector('[aria-invalid="true"]') || fallback)?.focus?.();
        }, 0);
    }, []);
};
